
import React, { useEffect, useState } from 'react';
import api from '../utils/api';

const CarList = () => {
	const [cars, setCars] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		let mounted = true;
		setLoading(true);
		api.get('/cars')
			.then(res => {
				if (mounted) {
					setCars(res.data.cars || []);
					setError(null);
				}
			})
			.catch(err => {
				if (mounted) {
					setError(err.response?.data?.message || 'Алдаа гарлаа');
				}
			})
			.finally(() => {
				if (mounted) setLoading(false);
			});
		return () => { mounted = false; };
	}, []);

	if (loading) return <div style={{ padding: 32 }}>Уншиж байна...</div>;
	if (error) return <div style={{ padding: 32, color: 'red' }}>{error}</div>;

	return (
		<div style={{ padding: 32 }}>
			<h2>Миний автомашинууд</h2>
			{cars.length === 0 ? (
				<div>Таны бүртгэлтэй автомашин алга байна.</div>
			) : (
				<ul style={{ listStyle: 'none', padding: 0 }}>
					{cars.map((car, idx) => (
						<li key={idx} style={{ marginBottom: 16, border: '1px solid #eee', borderRadius: 8, padding: 16, background: '#fafbfc' }}>
							<strong>{car.mark}</strong> — {car.plate} ({car.year})
						</li>
					))}
				</ul>
			)}
		</div>
	);
};

export default CarList;
